/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Party_Label_InfantsInputs */

const en_party_label_infants = /** @type {(inputs: Party_Label_InfantsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} infants`)
};

/**
* | output |
* | --- |
* | "{count} infants" |
*
* @param {Party_Label_InfantsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const party_label_infants = /** @type {((inputs: Party_Label_InfantsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Party_Label_InfantsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_party_label_infants(inputs)
});